/**
 * Design tokens for use in JS (e.g. inline styles).
 * CSS variables in index.css are the source of truth for theme.
 */
export const T = {
  bg: '#0e0e11',
  surface: '#141418',
  glass: 'rgba(255,248,230,0.03)',
  glassBorder: 'rgba(255,248,230,0.06)',
  glassHover: 'rgba(255,248,230,0.06)',
  gold: '#c8a45a',
  goldDim: 'rgba(200,164,90,0.15)',
  goldGlow: 'rgba(200,164,90,0.08)',
  green: '#4a9e6e',
  greenDim: 'rgba(74,158,110,0.12)',
  red: '#c45a4a',
  redDim: 'rgba(196,90,74,0.12)',
  amber: '#c89a4a',
  amberDim: 'rgba(200,154,74,0.12)',
  cream: 'rgba(255,248,230,0.85)',
  cream60: 'rgba(255,248,230,0.6)',
  cream35: 'rgba(255,248,230,0.35)',
  cream20: 'rgba(255,248,230,0.2)',
  cream12: 'rgba(255,248,230,0.12)',
  cream08: 'rgba(255,248,230,0.06)',
  cream04: 'rgba(255,248,230,0.03)',
  mono: "'IBM Plex Mono', monospace",
  sans: "'IBM Plex Sans', sans-serif",
  serif: "'Newsreader', Georgia, serif",
} as const;
